import AuthorizationWrapper, {
  authFnAllowOnlySAForMaintenance,
} from '@product-framework/components/AuthorizationWrapper';
import { FORM_ACTION, getRoutes } from '@ui-framework/index';
import ManagedNumberList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import ManagedNumberListStore from './store/list';

const Pages = ProtectedRoute => ({
  ManagedNumberList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ManagedNumberList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
      componentProps={{ action: FORM_ACTION.LIST }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    managedNumberListStore: new ManagedNumberListStore(rootStore),
  },
];

export { ManagedNumberList, routes, stores };
